import { MoonLoader } from 'react-spinners';

interface LoadingSpinnerProps {
  size?: number;
  color?: string;
  testId?: string;
}

export const LoadingSpinner = ({ size = 50, color = '#120f3a', testId }: LoadingSpinnerProps) => {
  return (
    <div
      className="flex items-center justify-center"
      data-testid={testId}
    >
      <MoonLoader
        size={size}
        color={color}
        loading={true}
      />
    </div>
  );
};
